import { atom } from "jotai";

/** The zero-based aggregate-request group currently shown by the wizard. */
export const CurrentRequestGroupIndexAtom = atom(0);
